import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { PROPERTIES } from "./apiRoutes";

const getPropertyByPropertyCategory = async (categoryIds: any, communityId: string) =>
  await axiosAuth.get(`${PROPERTIES(communityId)}/property-categories/${categoryIds}/dropdown`);

const useGetPropertyByPropertyCategory = ({
  categoryIds,
  communityId,
  queryParams,
}: {
  categoryIds: any;
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["property-by-property-category", categoryIds],
    queryFn: () => getPropertyByPropertyCategory(categoryIds, communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: queryParams?.enabled,
    ...queryParams,
  });
};

export default useGetPropertyByPropertyCategory;
